import type { CSSProperties } from 'react';
import { useBodyScrollLock } from '../../hooks/useBodyScrollLock.js';
import { useMediaQuery } from '../../hooks/useMediaQuery.js';

export const MOBILE_FLOATING_QUERY = '(max-width: 640px)';

export const MOBILE_FLOATING_PANEL_STYLE: CSSProperties = {
  position: 'fixed',
  top: 'auto',
  left: '8px',
  right: '8px',
  bottom: '8px',
  width: 'auto',
  maxWidth: 'none',
  maxHeight: 'min(70vh, calc(100vh - 32px))',
  transformOrigin: '50% 100%',
};

export function useMobileFloatingSheet(open: boolean): boolean {
  const mobile = useMediaQuery(MOBILE_FLOATING_QUERY);
  useBodyScrollLock(open && mobile);
  return mobile;
}
